import client from 'client';

import getAuthHeader from 'helpers/get-auth-header';

import { SERVER_URL } from 'constants/index';

const buildUrl = transferId => {
    return `${SERVER_URL}/api/v1/transfers/${transferId}/info`;
}

const fetchFiles = async (id, password) => {
    const url = buildUrl(id);
    let header = {};

    if (password) {
        header = getAuthHeader(password);
    }

    try {
        const result = await client.get(url, { headers: header, request: true })
    
        return { status: result.status, result: result.response }
    } catch(e) {
        return { status: e.status };
    }
}

export default fetchFiles;